import { call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_BATTLE_CARD_REQUEST, fetchBattleCardFailure, fetchBattleCardSuccess } from "../../actions/opportunities/battleCardActions";
import axios from "axios";
import qs from 'qs';
import iq_api_v2 from "../../../../services/iqApiV2";

async function findBattleCardData(opportunityId="") {
    const data = qs.stringify({
      opportunity_id: opportunityId,
    });
  
    // console.log("data",data)
    try {
      const response = await iq_api_v2.post("/opportunities/get_battlecard?"+data, '')
      return response?.data
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }

  }

// Worker Saga
function* fetchBattleCardSaga() {
  try {
    const payload = yield select(
      (state) => state?.battleCardReducer?.payload
    );
    const { opportunityId=""} = payload;
    const data = yield call(
        findBattleCardData,
        opportunityId
    );
    yield put(fetchBattleCardSuccess(data?.[0]));
  } catch (error) {
    yield put(fetchBattleCardFailure(error.message));
  }
}

// Watcher Saga
export function* watchBattleCardData() {
  yield takeLatest(FETCH_BATTLE_CARD_REQUEST, fetchBattleCardSaga);
}
